import React from 'react';
import './aiCard.css';

const Skeleton = ({ width = 24, height = 4, top = 0, left = 0 }) => {
  return <div className={`skeleton-container rounded-0.5 absolute w-${width} h-${height} top-${top} left-${left} `} />;
};
export default Skeleton;
